import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxResizeObserverModule } from 'ngx-resize-observer';

import { CountIndicatorModule, LetModule, RouterLinkModule } from '@hdms/shared/util-core';

import { ButtonModule } from '../button/button.module';
import { FlyoutModule } from '../flyout/flyout.module';
import { ButtonSliderArrowModule } from '../shared/button-slider/button-slider-arrow.module';
import { ButtonSliderService } from '../shared/button-slider/button-slider.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { AdditionalTabsButtonComponent } from './splittable-flyout-tabs/additional-tabs-button.component';
import { SplittableFlyoutTabsComponent } from './splittable-flyout-tabs/splittable-flyout-tabs.component';
import { TabContentComponent } from './tab-content.component';
import { TabGroupComponent } from './tab-group.component';
import { TabLinkComponent } from './tab-link.component';
import { TabSliderComponent } from './tab-slider.component';
import { TabComponent } from './tab.component';

@NgModule({
  declarations: [
    AdditionalTabsButtonComponent,
    SplittableFlyoutTabsComponent,
    TabComponent,
    TabContentComponent,
    TabGroupComponent,
    TabSliderComponent,
    TabLinkComponent
  ],
  imports: [
    ButtonModule,
    ButtonSliderArrowModule,
    CommonModule,
    CountIndicatorModule,
    FlyoutModule,
    NgxResizeObserverModule,
    RouterLinkModule,
    SvgIconModule,
    LetModule
  ],
  exports: [
    AdditionalTabsButtonComponent,
    SplittableFlyoutTabsComponent,
    TabComponent,
    TabContentComponent,
    TabGroupComponent,
    TabLinkComponent
  ],
  providers: [ButtonSliderService]
})
export class TabModule {}

export * from './splittable-flyout-tabs/additional-tabs-button.component';
export * from './splittable-flyout-tabs/splittable-flyout-tabs.component';
export * from './tab-content.component';
export * from './tab-group.component';
export * from './tab-link.component';
export * from './tab-slider.component';
export * from './tab-scope.directive';
export * from './tab.component';
